angular.module('impactx.catalog').controller('CatTrackListCtrl', CatTrackListCtrl);

CatTrackListCtrl.$inject = ['$scope', 'dataGen', '$mdToast', '$route', '$mdDialog', 'CatalogImportService', 'selectedListItems'];

function CatTrackListCtrl($scope, dataGen, $mdToast, $route, $mdDialog, CatalogImportService, selectedListItems) {
    var self = this;
    this.canCheck = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canCheck == 'true';
    };
    this.canViewBuyerCat = function() {
        if (!selectedListItems.isSingleSelection())
        {
            return false;
        }
        var item = selectedListItems.getFirstSelectedItem();
        return item.catId > 0 && !item.externalCatalog && !item.isSupplier.value;
    };

    this.canViewSupplierCat = function() {
        if (!selectedListItems.isSingleSelection())
        {
            return false;
        }
        var item = selectedListItems.getFirstSelectedItem();
        return item.catId > 0 && !item.externalCatalog && item.isSupplier.value;
    };

    this.getCheckLink = function() {
        var item = selectedListItems.getFirstSelectedItem();
        return "checkedoutcataloglist/" + (item != null ? item.checkOutCatId : "");
    };

    this.getViewBuyerCatLink = function() {
        var item = selectedListItems.getFirstSelectedItem();
        return "cataloglist/" + (item != null ? item.catId : "");
    };

    this.getViewSupplierCatLink = function() {
        var item = selectedListItems.getFirstSelectedItem();
        return "cataloglist/" + (item != null ? item.catId : "");
    };

    var buttonDefinition = [
        {label: "check", linkFunction: self.getCheckLink, type:'link', condition: self.canCheck, process: 'Catalog'},
        {label: "catalogdetails", linkFunction: self.getViewBuyerCatLink, type:'link', condition: self.canViewBuyerCat, process: 'Catalog'},
        {label: "catalogdetails", linkFunction: self.getViewSupplierCatLink, type:'link', condition: self.canViewSupplierCat, process: 'Catalog'}
    ];

    this.meta = {
        rowTemplate: 'modules/catalog/templates/cattracklist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/catalogtrack/list',
        ctrl: this,
        id: "cattracklist",
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };

}